// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"9688cc98","240":"6bbd165e","413":"dd4bba19","617":"dd4bba19","702":"f43641d0"}[chunkId] + ".chunk.css";
};